import _ from 'lodash';
import cookie from 'js-cookie';

export default class Utils {
  static createCookie(name, value, days) {
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      cookie.set(name, value, { path: '/', expires: date });
    } else {
      const date = new Date();
      date.setTime(date.getTime() + 365 * 2 * 24 * 60 * 60 * 1000);
      cookie.set(name, value, { path: '/', expires: date });
    }
  }

  static readCookie(name) {
    // if (typeof(window) !== 'undefined') {
    //   const temp = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    //   return temp ? temp.pop() : '';
    // }
    return cookie.get(name) || this.readCookieFromName(name);
  }

  static eraseCookie(name) {
    this.createCookie(name, '', -1);
  }

  static createToken(token) {
    this.createCookie('accessToken', token);
  }

  static getToken() {
    return this.readCookie('accessToken');
  }

  static isAuth(userStore) {
    return !!_.get(userStore, 'me.email');
  }

  static readCookieFromName(name = '', cookies = '') {
    const nameEQ = name.concat('=');
    const ca = cookies.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  static deleteToken() {
    cookie.remove('accessToken');
    // this.createCookie('accessToken', '');
  }

  static getBreadcrumbName(route, params) {
    if (!route.breadcrumbName) {
      return null;
    }
    if (_.includes(route.breadcrumbName, 'ignore')) {
      return null;
    }
    const paramsKeys = Object.keys(params).join('|');
    const name = route.breadcrumbName.replace(new RegExp(`:(${paramsKeys})`, 'g'), (replacement, key) => {
      return params[key] || replacement;
    });
    return name;
  }

  static slugify(text) {
    return (
      text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        // .replace(/[^\w\-]+/g, '') // Remove all non-word chars
        .replace(/--+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '')
    ); // Trim - from end of text
  }

  static FormatNumberLength(num, length) {
    let r = `${num}`;
    while (r.length < length) {
      r = `0${r}`;
    }
    return r;
  }

  static isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  static createQueryString(query) {
    if (_.isEmpty(query)) {
      return '';
    }
    let queryString = '?';
    _.forEach(query, (queryValue, key) => {
      if (queryValue) {
        queryString += `${key}=${queryValue}&`;
      }
    });
    queryString = _.trim(queryString, '&');
    console.log(queryString);
    return queryString;
  }
}
